import { UIDProvider } from 'dibs-uid';
import { object } from 'prop-types';
import { PrepareRelayContextProvider } from '../PrepareRelayContextProvider/PrepareRelayContextProvider';
import Footer from '../Footer/Footer';

const FooterRenderer = props => {
    const { environment, initialVariables, query } = props;

    return (
        <UIDProvider prefix="footer">
            <PrepareRelayContextProvider
                environment={environment}
                query={query}
                variables={initialVariables}
                render={({ props: rendererProps }) => <Footer {...rendererProps} />}
            />
        </UIDProvider>
    );
};

FooterRenderer.propTypes = {
    environment: object,
    initialVariables: object,
    query: object,
};

export default FooterRenderer;
